import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Async thunks
export const checkFollowing = createAsyncThunk(
  'follow/checkFollowing',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/users/${userId}/is-following`);
      return { userId, isFollowing: response.data.isFollowing };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la vérification du suivi');
    }
  }
);

export const followUser = createAsyncThunk(
  'follow/followUser',
  async (userId, { rejectWithValue }) => {
    try {
      await api.post(`/users/${userId}/follow`);
      return { userId };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors du suivi');
    }
  }
);

export const unfollowUser = createAsyncThunk(
  'follow/unfollowUser',
  async (userId, { rejectWithValue }) => {
    try {
      await api.delete(`/users/${userId}/follow`);
      return { userId };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors du désabonnement');
    }
  }
);

const initialState = {
  followingStatus: {}, // { [userId]: boolean }
  loading: false,
  error: null,
};

const followSlice = createSlice({
  name: 'follow',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Check Following
      .addCase(checkFollowing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkFollowing.fulfilled, (state, action) => {
        state.loading = false;
        state.followingStatus[action.payload.userId] = action.payload.isFollowing;
      })
      .addCase(checkFollowing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Follow User
      .addCase(followUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(followUser.fulfilled, (state, action) => {
        state.loading = false;
        state.followingStatus[action.payload.userId] = true;
      })
      .addCase(followUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Unfollow User
      .addCase(unfollowUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(unfollowUser.fulfilled, (state, action) => {
        state.loading = false;
        state.followingStatus[action.payload.userId] = false;
      })
      .addCase(unfollowUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = followSlice.actions;
export default followSlice.reducer;
